import { combineSlices } from '@reduxjs/toolkit'
import { authApi } from 'api/authApi'
import clientsApi from 'api/clientsApi'
import developerApi from 'api/developerApi'
import projectApi from 'api/projectApi'
import plotApi from 'api/plotApi'
import bookingApi from 'api/bookingApi'
import paymentApi from 'api/paymentApi'
import documentApi from 'api/documentApi'
import notificationApi from 'api/notificationApi'
import reportApi from 'api/reportApi'
import brokerApi from 'api/brokerApi'
import customerApi from 'api/customerApi'
import tenantApi from 'api/tenantApi'
import userAdminApi from 'api/userAdminApi'
import lookupApi from 'api/lookupApi'
import moduleConfigApi from 'api/moduleConfigApi'
import taskApi from 'api/taskApi'
import communicationApi from 'api/communicationApi'
import projectSelectionSlice from 'api/projectSelectionApi'

const rootReducer = combineSlices(
  clientsApi,
  authApi,
  developerApi,
  projectApi,
  plotApi,
  bookingApi,
  paymentApi,
  documentApi,
  notificationApi,
  reportApi,
  brokerApi,
  customerApi,
  tenantApi,
  userAdminApi,
  lookupApi,
  moduleConfigApi,
  taskApi,
  communicationApi,
  projectSelectionSlice
)

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
